'use client'

import { usePathname } from 'next/navigation'
import { useEffect, useRef } from 'react'

/**
 * Compteur de pages vues.
 *
 * Envoie un signal au serveur à chaque changement de page. **Rien n'est
 * stocké dans le navigateur** : ni cookie, ni localStorage, ni identifiant.
 * Le serveur n'incrémente qu'un compteur par jour et par page, donc le
 * bandeau de consentement ne le concerne pas.
 *
 * Le garde-fou `sent` évite de compter deux fois la même page lors des
 * re-rendus de React — sans lui, le mode strict doublerait chaque vue.
 */
export function PageViewTracker({ locale }: { locale: string }) {
  const pathname = usePathname()
  const sent = useRef<string | null>(null)

  useEffect(() => {
    if (!pathname || sent.current === pathname) return
    sent.current = pathname

    void fetch('/api/track', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ path: pathname, lang: locale }),
      keepalive: true,
    }).catch(() => null)
  }, [pathname, locale])

  return null
}
